import * as React from "react";
import { IS_DEPLOYMENT_ENV_PROD, STORAGE_KEY_CAPTURED_COOKIE } from "../../../../envVariables";
import { Loader } from "../../../../components/layout/loader";

interface Props extends React.PropsWithChildren {}
export const LayerCaptureCookie: React.FC<Props> = ({ children }) => {
  const [processed, setProcessed] = React.useState(false);

  React.useEffect(() => {
    process();
  }, []);

  async function process() {
    if (!IS_DEPLOYMENT_ENV_PROD) {
      setProcessed(true);
      return;
    }

    const alreadyChecked = (localStorage.getItem(STORAGE_KEY_CAPTURED_COOKIE) || "false") === "true";
    if (alreadyChecked) {
      setProcessed(true);
      return;
    }

    localStorage.setItem(STORAGE_KEY_CAPTURED_COOKIE, "true");
    // @ts-ignore
    window.location = `https://signup.controlplane.com/check`;
    return;
  }

  if (!processed) {
    return <Loader />;
  }

  return children;
};
